import { render, staticRenderFns } from "./GenralReportsTable.vue?vue&type=template&id=0ffdc980&"
import script from "./GenralReportsTable.vue?vue&type=script&lang=js&"
export * from "./GenralReportsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports